import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Video } from 'app/_model/video/video';
import { Utility } from 'app/_service/utility';
import { playerUtil } from 'app/video/videoplayer/videoplayer.utils';

export enum VideoDisplay {
  Full,
  Teaser,
  SmallTeaser,
  Compact,
  Detail,
  SearchList,
  News,
  NewsBlock,
  ChannelBlock
}

@Component({
  selector: 'div.new-svideo-container',
  templateUrl: './new-svideo-container.component.html',
  styleUrls: ['./new-svideo-container.component.scss']
})
export class NewSvideoContainerComponent implements OnInit {

  @Input()
  video: Video;

  @Input()
  display = VideoDisplay.Teaser;

  @Input()
  posterHeight = 165;

  videoDisplay = VideoDisplay;

  @Input()
  posterWidth = 315;

  @Input() fromSvideoPage = false;

  showPlayer = false;
  mediaKey = '';
  pendingPlayList = {
    medias:null
  };

  //@Input() playingMediaKey = '';
  @Output() currentMediaKey = new EventEmitter<any>();

  isHovered = false;
  playSuccess = false;
  @Output() playerShowed = new EventEmitter<any>();

  isTouchDevice = playerUtil.isTouchDevice();
  constructor(
    private _utility: Utility,
  ) { }

  ngOnInit(): void {
    this.mediaKey = this.video.key
  }

  // replaceImage(image) {
  //   return image.replace("s.",".");
  // }
  //api;

  onPlayerReady($event) {
    //this.api = $event;
    // this.api = $event;
    // this.playOrWait();
    // let lastTimer = null;
    // this.api.subscript('time', (time) => {
    // });
    // this.api.subscript('ended', () => {
    // });
    // this.api.subscript("fullscreen", (isfull) => {
    // });
    // this.api.subscript('play', () => {
    //   this.playerLoading = false;
    // });
  }

  private getType(isHls: boolean) {
    return isHls ? 'application/vnd.apple.mpegurl' : 'video/mp4';
  }

  private converHtml5ToMedia(container) {
    return {
      title: '',
      src: container.result,
      length: 0,
      type: this.getType(container.isHls),
      href: decodeURIComponent(container.link),
      isStream: container.type === 0,
      isAd: !!container.link,
      isHls: container.isHls,
      isImage: container.result
        && (container.result.indexOf('.jpg') > -1
          || container.result.indexOf('.png') > -1
          || container.result.indexOf('.gif') > -1),
      backup: container.backup,
      rtmp: container.rtmp,
    };
  }

  private assingPendding(key, value) {
    this.pendingPlayList[key] = value;
  }
  playerTimeout;
  openPlayer() {
    if (this.isTouchDevice) {
      return;
    }
    if (this.isHovered) {
      return;
    }
    
    // 停留200ms再打开播放器
    this.isHovered = true;
    clearTimeout(this.playerTimeout);
    this.playerTimeout =  setTimeout((bind) =>{
      if (this.isHovered) {
        const flvPathObj = {
          backup: null,
          bitrate: 0,
          broker: null,
          isHls: true,
          link: null,
          result: this._utility.GetHost(`https://upload.{Host}/api/video/MasterPlayList?id=${this.mediaKey}`),
          rtmp: null,
          type: 0,
          validator: null,
        };
        let medias = [];
        let item = this.converHtml5ToMedia(flvPathObj);
          item.title = this.video.title;
          medias.push(item);
        this.assingPendding('medias', medias);
        this.showPlayer = true; // 打开播放器
        this.currentMediaKey.emit(this.mediaKey);
      }
    }, 200);
  }

  onMouseLeave() {
    // console.log("mouse leave")
    this.isHovered = false;
    clearTimeout(this.playerTimeout);
    this.onPlayEnd();
  }

  onPlayStart() {
    this.playSuccess = true;
    this.playerShowed.emit(this.playSuccess);
  }

  onPlayEnd() {
    this.showPlayer = false;
    this.playSuccess = false;
    this.playerShowed.emit(this.playSuccess);
  }

}
